/**
 * Tool Input Summary Component
 *
 * Displays the input parameters that were passed to a tool in a compact format.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ToolInputSummary({ inputs, maxInputs = 4 }) {
    if (!inputs || inputs.length === 0) {
        return null;
    }
    const visibleInputs = inputs.slice(0, maxInputs);
    const hiddenCount = inputs.length - maxInputs;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-wrap items-center gap-x-3 gap-y-1 text-xs",
        children: [
            visibleInputs.map((input, index)=>/*#__PURE__*/ _jsxs("span", {
                    className: "flex items-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsxs("span", {
                            className: "font-medium",
                            children: [
                                input.label,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: input.value
                        }),
                        index < visibleInputs.length - 1 && /*#__PURE__*/ _jsx("span", {
                            className: "opacity-30 ml-1",
                            children: "|"
                        })
                    ]
                }, input.label)),
            hiddenCount > 0 && /*#__PURE__*/ _jsxs("span", {
                className: "opacity-70",
                children: [
                    "+",
                    hiddenCount,
                    " more"
                ]
            })
        ]
    });
}
